export const PRODUCT_REQUEST="PRODUCT_REQUEST"
export const PRODUCT_FAILURE="PRODUCT_FAILURE"


// post
export const POST_PRODUCT_SUCCESS="POST_PRODUCT_SUCCESS"

// get
export const GET_PRODUCT_SUCCESS="GET_PRODUCT_SUCCESS"

// patch
export const PATCH_PRODUCT_SUCCESS="PATCH_PRODUCT_SUCCESS"


export const ADD_TO_CART="ADD_TO_CART"
export const REMOVE_ITEM="REMOVE_ITEM"
export const CLEAR_CART="CLEAR_CART"
export const INCREMENT_QUANTITY="INCREMENT_QUANTITY"
export const DECREMENT_QUANTITY="DECREMENT_QUANTITY"
export const TOTAL_PRICE="TOTAL_PRICE"